module.exports = __webpack_public_path__ + "img/40_38_027_410.7b8870cf.jpg";